import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    url: '',
    display: '1',
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  containerDesign: {},
};

export const twitchSlice = createSlice({
  name: 'twitch',
  initialState,
  reducers: {
    twitchStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        url: blockContent.url ?? '',
        display: blockContent.display ?? '1',
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
    },
    twitchClear: () => initialState,

    twitchUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    twitchUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    twitchUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
  },
});

export const { twitchStore, twitchClear, twitchUpdateIsLoading, twitchUpdateIsActive, twitchUpdateBlockContent } = twitchSlice.actions;

export const selectTwitchIsLoading = (state) => state.twitch.isLoading;

export const selectTwitchId = (state) => state.twitch.id;
export const selectTwitchUID = (state) => state.twitch.uid;
export const selectTwitchSID = (state) => state.twitch.sid;

export const selectTwitchBlockContent = (state) => state.twitch.blockContent;
export const selectTwitchContainerDesign = (state) => state.twitch.containerDesign;

export default twitchSlice.reducer;
